import React, {Component} from 'react';
import {FormControl, Icon, InputLabel, MenuItem, Select} from '@material-ui/core';
import PropTypes from "prop-types"; // 參考資料 : https://www.npmjs.com/package/prop-types

class UecareDropdown extends Component {

    static propTypes = {
        icon: PropTypes.string,
        className: PropTypes.any,
        label: PropTypes.string,
        disabled: PropTypes.bool,
        value: PropTypes.any.isRequired,
        options: PropTypes.array.isRequired,
        id: PropTypes.string,
        name: PropTypes.string,
        onChange: PropTypes.func,
        multiple: PropTypes.bool,
    };

    render() {

        return (
            <div className="flex">
                <div className="min-w-48 pt-20">
                    <Icon color="action">{this.props.icon}</Icon>
                </div>
                <FormControl className={this.props.className} fullWidth>
                    <InputLabel>
                        {this.props.label}
                    </InputLabel>
                    <Select
                        disabled={this.props.disabled}
                        value={this.props.value}
                        multiple={this.props.multiple}
                        onChange={(event) => {

                            let selectedOption = this.props.options.find((option) => {
                                return event.target.value === option.id;
                            });

                            this.props.onChange(event, selectedOption);
                        }}
                        inputProps={{
                            name: `${this.props.name}`,
                            id: `${this.props.id}`,
                        }}
                    >
                        <MenuItem key={0} value={0} disabled>請選擇{this.props.label}</MenuItem>
                        {
                            Object.values(this.props.options).filter((option) => {
                                return option.name;
                            }).map((option, index) => {
                                return (
                                    <MenuItem key={index} value={option.id}>{option.name}</MenuItem>)
                            })
                        }
                    </Select>
                </FormControl>
            </div>
        );
    }
}

export default UecareDropdown;



// WEBPACK FOOTER //
// ./src/components/UecareDropdown.js